import React, { useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import {
  LayoutElementState,
  useLayoutContext,
} from '../../context/LayoutContext';
import { LEFT_RAIL_WIDTH, LEFT_RAIL_WIDTH_COLLAPSED } from '.';

const useStyles = makeStyles()(theme => ({
  root: {
    borderRight: `1px solid ${palette.gray_800}`,
    height: '100%',
    transition: theme.transitions.create(['width'], {
      easing: 'cubic-bezier(0.25, 0.25, 0.5, 1)',
      duration: 600,
    }),
    width: LEFT_RAIL_WIDTH_COLLAPSED,
    '&:has(:focus-visible)': {
      borderRadius: theme.spacing(0.5),
      outline: `2px solid ${palette.mint_200}`,
      outlineOffset: `-2px`,
    },
    zIndex: theme.zIndex.drawer + 1,
  },
  expanded: {
    width: LEFT_RAIL_WIDTH,
  },
}));

interface LeftRailProps {
  children: React.ReactNode;
}

/**
 * @description A layout component for the left rail which can be toggled open or closed. This rail
 *            is expected to contain navigation links and other content. The left rail is hidden on
 *           mobile devices.
 */
export default function LeftRail({ children }: LeftRailProps) {
  const { isLeftRailOpen, isLeftRailHidden, setLeftRailVisibility } =
    useLayoutContext();
  const { classes, cx } = useStyles();

  useEffect(() => {
    if (!children && !isLeftRailHidden) {
      setLeftRailVisibility(LayoutElementState.HIDDEN);
    }
  }, [isLeftRailHidden, setLeftRailVisibility, children]);

  return !isLeftRailHidden ? (
    <aside
      className={cx(classes.root, {
        [`${classes.expanded}`]: isLeftRailOpen,
      })}
      aria-label="Main Menu"
    >
      {children}
    </aside>
  ) : null;
}
